<template>
	<div class="story_list_item_container">
		
		<div class="story_list_item"
		:class="$mq"
		@click="open_story_url(link)"
		>
		
			<div class="story_item_image" 
			:style="{'background-image': 'url(\'' + master_image_url + '\')'}"
			></div>

			<span class="story_item_title">{{title}}</span>

		</div>

	</div>
</template>

<script>
export default {
	name: 'story_list_item',
	props: [
		'link',
		'master_image_url',
		'title'
	],
	data () {
		return {
			
		}
	},
	computed: {
		
	},
	methods: {
		open_story_url: function(url) {
			let vm = this;

			// FIRE GA EVENT
			vm.$ga.event({
				eventCategory: 'Outbound Link',
				eventAction: 'click',
				eventLabel: url
			})

			// ADD TRACKING STRING
			url += '?source=best_of_dayton_pwa&item=story_card'
			window.open(url);
		},
	},
	components: {
		
	}
}
</script>

<style lang="scss">
@import '@/styles/global_styles.scss';

.story_list_item_container {

	.story_list_item {
		/*border: solid 1px blue;*/
		margin: 1em 0;
		cursor: pointer;

		.story_item_title {
			font-size: 0.9em;
			line-height: 0.5em;
		}

		.story_item_image {
			width: 100%;
			height: 100px;
			background-size: cover;
		}

		&.desktop, &.laptop {

			.story_item_image {
				height: 250px;
			}

			.story_item_title {
				
				&:hover {
					color: blue;
				}
			}
		
		}
	}

}

</style>



// WEBPACK FOOTER //
// src/components/lists/story_list_item.vue